import { defineComponent, nextTick, reactive, ref } from 'vue';
import { gsap } from 'gsap';
import EnergyTableRow from '@hems/user/src/components/table/EnergyTableRow.vue';
export default defineComponent({
    name: 'EnergyTable',
    components: {
        EnergyTableRow,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    setup() {
        const overBox = ref(null);
        const state = reactive({
            show: true,
        });
        async function enter(animation) {
            if ((overBox.value?.offsetTop || 0) == 0) {
                await gsap.set([overBox.value], {
                    left: animation.left,
                    height: animation.height,
                    width: animation.width,
                });
            }
            gsap.to([overBox.value], animation);
        }
        async function leave() {
            await gsap.to([overBox.value], {
                opacity: '0',
                transition: 'all .1s, opacity .1s',
            });
            state.show = false;
            nextTick(() => {
                state.show = true;
            });
        }
        return {
            overBox,
            enter,
            leave,
            state,
        };
    },
});
